"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayStatisticsDisplaysPageEntity = exports.DisplayStatisticsEntity = exports.DisplayStatisticsDisplayEntity = exports.DisplayStatisticsHeatmapPointEntity = exports.DisplayStatisticsTrendPointEntity = exports.DisplayStatisticsSummaryEntity = exports.DisplayStatisticsQualityEntity = exports.DisplayStatisticsMetricEntity = exports.DisplayStatisticsPeriodEntity = void 0;
class DisplayStatisticsPeriodEntity {
    from;
    to;
}
exports.DisplayStatisticsPeriodEntity = DisplayStatisticsPeriodEntity;
class DisplayStatisticsMetricEntity {
    expectedSeconds;
    connectedSeconds;
    missedSeconds;
    availabilityPercent;
}
exports.DisplayStatisticsMetricEntity = DisplayStatisticsMetricEntity;
class DisplayStatisticsQualityEntity {
    highSeconds;
    mediumSeconds;
    lowSeconds;
    unavailableDisplays;
    availableDisplays;
    coveragePercent;
}
exports.DisplayStatisticsQualityEntity = DisplayStatisticsQualityEntity;
class DisplayStatisticsSummaryEntity extends DisplayStatisticsMetricEntity {
    requestedDisplays;
    resolvedDisplays;
    omittedDisplays;
    scheduledDisplays;
    currentConnectedDisplays;
    currentDisconnectedDisplays;
    healthyDisplays;
    atRiskDisplays;
    criticalDisplays;
    noScheduleDisplays;
    unknownDisplays;
    improvedDisplays;
    worsenedDisplays;
    unchangedDisplays;
    averageConnectedSecondsPerDisplayDay;
    averageConnectedSecondsPerDisplayWeek;
    comparisonAvailabilityPercent;
    availabilityDeltaPercent;
}
exports.DisplayStatisticsSummaryEntity = DisplayStatisticsSummaryEntity;
class DisplayStatisticsTrendPointEntity extends DisplayStatisticsMetricEntity {
    date;
    label;
    comparisonExpectedSeconds;
    comparisonConnectedSeconds;
    comparisonAvailabilityPercent;
}
exports.DisplayStatisticsTrendPointEntity = DisplayStatisticsTrendPointEntity;
class DisplayStatisticsHeatmapPointEntity extends DisplayStatisticsMetricEntity {
    weekday;
    hour;
}
exports.DisplayStatisticsHeatmapPointEntity = DisplayStatisticsHeatmapPointEntity;
class DisplayStatisticsDisplayEntity extends DisplayStatisticsMetricEntity {
    displayId;
    ref;
    name;
    displayTechInfo;
    timeZone;
    hasSchedule;
    schedule;
    status;
    isConnected;
    lastConnectionAt;
    peakOperationalHour;
    source;
    confidence;
    comparisonAvailabilityPercent;
    availabilityDeltaPercent;
    comparisonConnectedSeconds;
    connectedSecondsDelta;
}
exports.DisplayStatisticsDisplayEntity = DisplayStatisticsDisplayEntity;
class DisplayStatisticsEntity {
    period;
    comparisonPeriod;
    generatedAt;
    summary;
    quality;
    trend;
    heatmap;
    worstDisplays;
    improvingDisplays;
    worseningDisplays;
    largestConnectedTimeChanges;
}
exports.DisplayStatisticsEntity = DisplayStatisticsEntity;
class DisplayStatisticsDisplaysPageEntity {
    results;
    total;
    page;
    limit;
}
exports.DisplayStatisticsDisplaysPageEntity = DisplayStatisticsDisplaysPageEntity;
